// extracted by mini-css-extract-plugin
export default {"main":"Redirect_page_main__6DuAf"};